import '../pages.css';
import { useState } from 'react';

async function hashUserId(userId) {
  const encoded = new TextEncoder().encode(userId);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
  const bytes = new Uint8Array(hashBuffer, 0, 8);
  // Convert first 8 bytes to a decimal string representing a big-endian uint64.
  // Use hex string arithmetic to avoid JS 53-bit float precision loss.
  const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
  return BigInt('0x' + hex).toString();
}

function UserIdHasher() {
  const [userId, setUserId] = useState('');
  const [result, setResult] = useState(null);
  const [copied, setCopied] = useState(false);

  const handleHash = async () => {
    if (!userId.trim()) return;
    const hash = await hashUserId(userId.trim());
    setResult(hash);
    setCopied(false);
  };

  const handleCopy = () => {
    if (result) {
      navigator.clipboard.writeText(result);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleHash();
  };

  return (
    <div className="application-container">
      <div className="container" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
        <div className="header">
          <h1>User ID Hasher</h1>
        </div>
        <div className="card" style={{ width: '560px', marginLeft: '5%' }}>
          <h2>Hash User ID</h2>
          <p>Converts a user ID to its numeric hash.</p>
          <input
            type="text"
            placeholder="Enter user ID (e.g. 22351d74-5bcf-45a4-a8f8-4e9632d8e291)"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{
              width: '100%',
              padding: '10px',
              marginBottom: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              boxSizing: 'border-box',
              fontFamily: 'monospace',
            }}
          />
          <button onClick={handleHash} style={{ marginBottom: result ? '15px' : '0' }}>
            Hash
          </button>
          {result && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginTop: '15px',
                padding: '10px 14px',
                background: '#f0f0f0',
                borderRadius: '5px',
                border: '1px solid #ddd',
              }}
            >
              <span style={{ fontFamily: 'monospace', fontSize: '1em', flex: 1, wordBreak: 'break-all' }}>
                {result}
              </span>
              <button
                onClick={handleCopy}
                style={{
                  width: 'auto',
                  padding: '6px 12px',
                  fontSize: '0.85em',
                  backgroundColor: copied ? '#4caf50' : '#6f020d',
                  flexShrink: 0,
                }}
              >
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserIdHasher;
